/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineUploadDateFields,
    MachineUploadDateFieldsFromJSON,
    MachineUploadDateFieldsFromJSONTyped,
    MachineUploadDateFieldsToJSON,
} from './MachineUploadDateFields';

/**
 * 
 * @export
 * @interface MachineListSearchFilterModel
 */
export interface MachineListSearchFilterModel {
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    machineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    cityId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    districtId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineListSearchFilterModel
     */
    categoryIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineListSearchFilterModel
     */
    subCategoryIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineListSearchFilterModel
     */
    brandIds?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    rentalTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxPrice?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineListSearchFilterModel
     */
    hasOperator?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineListSearchFilterModel
     */
    hasPicture?: boolean | null;
    /**
     * 
     * @type {MachineUploadDateFields}
     * @memberof MachineListSearchFilterModel
     */
    machineUploadDate?: MachineUploadDateFields;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minOperationMillage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxOperationMillage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minNominalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxNominalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    minHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineListSearchFilterModel
     */
    maxHeight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineListSearchFilterModel
     */
    drivingEquipment?: string | null;
}

export function MachineListSearchFilterModelFromJSON(json: any): MachineListSearchFilterModel {
    return MachineListSearchFilterModelFromJSONTyped(json, false);
}

export function MachineListSearchFilterModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineListSearchFilterModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machineId': !exists(json, 'machineId') ? undefined : json['machineId'],
        'cityId': !exists(json, 'cityId') ? undefined : json['cityId'],
        'districtId': !exists(json, 'districtId') ? undefined : json['districtId'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'subCategoryIds': !exists(json, 'subCategoryIds') ? undefined : json['subCategoryIds'],
        'brandIds': !exists(json, 'brandIds') ? undefined : json['brandIds'],
        'rentalTypeId': !exists(json, 'rentalTypeId') ? undefined : json['rentalTypeId'],
        'minPrice': !exists(json, 'minPrice') ? undefined : json['minPrice'],
        'maxPrice': !exists(json, 'maxPrice') ? undefined : json['maxPrice'],
        'hasOperator': !exists(json, 'hasOperator') ? undefined : json['hasOperator'],
        'hasPicture': !exists(json, 'hasPicture') ? undefined : json['hasPicture'],
        'machineUploadDate': !exists(json, 'machineUploadDate') ? undefined : MachineUploadDateFieldsFromJSON(json['machineUploadDate']),
        'minProductionYear': !exists(json, 'minProductionYear') ? undefined : json['minProductionYear'],
        'maxProductionYear': !exists(json, 'maxProductionYear') ? undefined : json['maxProductionYear'],
        'minOperatingWeight': !exists(json, 'minOperatingWeight') ? undefined : json['minOperatingWeight'],
        'maxOperatingWeight': !exists(json, 'maxOperatingWeight') ? undefined : json['maxOperatingWeight'],
        'minOperationHour': !exists(json, 'minOperationHour') ? undefined : json['minOperationHour'],
        'maxOperationHour': !exists(json, 'maxOperationHour') ? undefined : json['maxOperationHour'],
        'minCarryingCapacity': !exists(json, 'minCarryingCapacity') ? undefined : json['minCarryingCapacity'],
        'maxCarryingCapacity': !exists(json, 'maxCarryingCapacity') ? undefined : json['maxCarryingCapacity'],
        'minOperatingHeight': !exists(json, 'minOperatingHeight') ? undefined : json['minOperatingHeight'],
        'maxOperatingHeight': !exists(json, 'maxOperatingHeight') ? undefined : json['maxOperatingHeight'],
        'minOperationMillage': !exists(json, 'minOperationMillage') ? undefined : json['minOperationMillage'],
        'maxOperationMillage': !exists(json, 'maxOperationMillage') ? undefined : json['maxOperationMillage'],
        'minEnginePower': !exists(json, 'minEnginePower') ? undefined : json['minEnginePower'],
        'maxEnginePower': !exists(json, 'maxEnginePower') ? undefined : json['maxEnginePower'],
        'minMaxPower': !exists(json, 'minMaxPower') ? undefined : json['minMaxPower'],
        'maxMaxPower': !exists(json, 'maxMaxPower') ? undefined : json['maxMaxPower'],
        'minVolume': !exists(json, 'minVolume') ? undefined : json['minVolume'],
        'maxVolume': !exists(json, 'maxVolume') ? undefined : json['maxVolume'],
        'minNominalCapacity': !exists(json, 'minNominalCapacity') ? undefined : json['minNominalCapacity'],
        'maxNominalCapacity': !exists(json, 'maxNominalCapacity') ? undefined : json['maxNominalCapacity'],
        'minHeight': !exists(json, 'minHeight') ? undefined : json['minHeight'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
    };
}

export function MachineListSearchFilterModelToJSON(value?: MachineListSearchFilterModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineId': value.machineId,
        'cityId': value.cityId,
        'districtId': value.districtId,
        'categoryIds': value.categoryIds,
        'subCategoryIds': value.subCategoryIds,
        'brandIds': value.brandIds,
        'rentalTypeId': value.rentalTypeId,
        'minPrice': value.minPrice,
        'maxPrice': value.maxPrice,
        'hasOperator': value.hasOperator,
        'hasPicture': value.hasPicture,
        'machineUploadDate': MachineUploadDateFieldsToJSON(value.machineUploadDate),
        'minProductionYear': value.minProductionYear,
        'maxProductionYear': value.maxProductionYear,
        'minOperatingWeight': value.minOperatingWeight,
        'maxOperatingWeight': value.maxOperatingWeight,
        'minOperationHour': value.minOperationHour,
        'maxOperationHour': value.maxOperationHour,
        'minCarryingCapacity': value.minCarryingCapacity,
        'maxCarryingCapacity': value.maxCarryingCapacity,
        'minOperatingHeight': value.minOperatingHeight,
        'maxOperatingHeight': value.maxOperatingHeight,
        'minOperationMillage': value.minOperationMillage,
        'maxOperationMillage': value.maxOperationMillage,
        'minEnginePower': value.minEnginePower,
        'maxEnginePower': value.maxEnginePower,
        'minMaxPower': value.minMaxPower,
        'maxMaxPower': value.maxMaxPower,
        'minVolume': value.minVolume,
        'maxVolume': value.maxVolume,
        'minNominalCapacity': value.minNominalCapacity,
        'maxNominalCapacity': value.maxNominalCapacity,
        'minHeight': value.minHeight,
        'maxHeight': value.maxHeight,
        'drivingEquipment': value.drivingEquipment,
    };
}

